// video-on-active-slide.js

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const slideshow = document.querySelector('slideshow-slides');

    if (!slideshow) {
      console.warn('slideshow-slides not found on page');
      return;
    }

    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    if (!slides.length) {
      console.warn('No slideshow-slide elements found');
      return;
    }

    function getActiveSlide() {
      return slideshow.querySelector('slideshow-slide[aria-hidden="false"]');
    }

    function loadVideoInSlide(slide) {
      if (!slide) return;

      const deferred = slide.querySelector('deferred-media');
      if (!deferred) return;

      // 1) If video not loaded yet → click poster play button (theme handles everything)
      let video = deferred.querySelector('video');
      if (!video) {
        const playBtn = deferred.querySelector('[ref="deferredMediaPlayButton"]');
        if (playBtn) {
          playBtn.click();
        }
        // After click, try to get video again
        video = deferred.querySelector('video');
      }

      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('autoplay', 'autoplay');

      // 2) If already loaded and currently paused → use theme's toggle button
      const toggleBtn = deferred.querySelector('[ref="toggleMediaButton"]');

      if (video.paused) {
        if (toggleBtn) {
          // This will:
          // - play the video
          // - update play/pause icons correctly (no mismatch)
          toggleBtn.click();
        } else {
          // Fallback: direct play if no toggle button exists
          video.play().catch(function (err) {
            console.warn('Video autoplay might be blocked by browser:', err);
          });
        }
      }
    }

    function pauseVideoInSlide(slide) {
      if (!slide) return;

      const deferred = slide.querySelector('deferred-media');
      if (!deferred) return;

      const video = deferred.querySelector('video');
      if (video && !video.paused) {
        video.pause();
        // We intentionally do NOT touch icons here.
        // Theme will still think it's in "pause" state, which is fine when slide is hidden.
      }
    }

    function pauseVideoMine(slide){
      slide = document.querySelector('.product-media-container--video');
      console.log(slide);
      if (!slide) return;
      const deferred1 = slide.querySelector('deferred-media');
      console.log(deferred1);
      if (!deferred1) return;
      const video1 = deferred1.querySelector('video');
      console.log(video1);
      if (!video1) {
        const playBtn1 = deferred1.querySelector('[ref="toggleMediaButton"]');
        if (playBtn1) {
          playBtn1.click();
        }
      }else{
        video1.pause();
      }
    }

    function playVideoMine(slide) {
      if (!slide) return;
      const deferred = slide.querySelector('deferred-media');
      if (!deferred) return;
      const video = deferred.querySelector('video');
      if (!video) {
        const playBtn = deferred.querySelector('[ref="deferredMediaPlayButton"]');
        if (playBtn) {
          playBtn.click();
        }
      }else{
        video.play();
      }
    }

    let currentActive = getActiveSlide();
    if (currentActive) {
      loadVideoInSlide(currentActive);
    }

    function handleActiveChange() {
      const newActive = getActiveSlide();
      if(newActive.classList.contains("product-media-container--video")){
        playVideoMine(newActive);
      }else {
        pauseVideoMine(currentActive);
      }
      // if (newActive === currentActive) return;
      // console.log(newActive.classList.contains("product-media-container--video"));
      // if (currentActive) {
      //   pauseVideoInSlide(currentActive);
      // }

      // currentActive = newActive;

      // if (currentActive) {
      //   loadVideoInSlide(currentActive);
      // }
    }

    const observer = new MutationObserver(function (mutations) {
      let shouldCheck = false;

      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          shouldCheck = true;
          break;
        }
      }

      if (shouldCheck) {
        handleActiveChange();
      }
    });

    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true });
    });
  });
})();
